import { render, staticRenderFns } from "./FormWidget.vue?vue&type=template&id=6f80f04d&scoped=true"
import script from "./FormWidget.vue?vue&type=script&lang=js"
export * from "./FormWidget.vue?vue&type=script&lang=js"
import style0 from "./FormWidget.vue?vue&type=style&index=0&id=6f80f04d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f80f04d",
  null
  
)

export default component.exports